<template>
  <v-container class="p-order-detail">
    <v-layout v-if="policy">
      <v-flex>
         <aig :policy="policy" v-if="this.productIds.indexOf(Number(this.productId)) !== -1"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import aig from "./components/apply.vue"
export default {
  props: {
    policyCode: String
  },
  components: {
    aig
  },
  data() {
    return {
      policy: null,
      urlData:[
        {
          productId:2016,
          url:'/app/api/heshunbao/getEndorsement'
        },
        {
          productId:2017,
          url:'/app/api/heshunbao/b/getEndorsement'
        }
      ],
      userId:null,
      productIds: [2016, 2017]
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    productId() {
      return this.$route.query.productId;
    },
    apiUrl(){
      return this.urlData.find(item => item.productId == this.productId).url;
    }
  },
  created() {
    this.$store.dispatch("getUserInfo", true).then(user => {
      if (user) {
        this.userId = user.userId;
        this.getData();
      }
    });
  },
  methods: {
    getData() {
      this.$axios
      .get(this.apiUrl+'?endorsementCode='+this.policyCode)
      .then(res => {
        console.log(res)
        this.policy = res.data;
      })
      .catch(err => {
        this.$message.error("保单员工信息异常：" + err);
      });
    },
    toPay(){
      const orderCode = this.policy.policy.orderCode;
      this.$router.push({ name: "tkpay", params: { orderCode } });
    }
  }
};
</script>

<style lang="scss">
.p-order-detail {
  .download-link {
    font-size: 14px;
    color: $primary-color;
    margin-left: 15px;
  }
  .operation {
    width: 330px;
    flex: none;
    .card {
      padding: 30px 25px;
      margin-bottom: 20px;
      font-size: 14px;
      .money {
        font-size: 34px;
        line-height: 34px;
        font-weight: 500;
      }
    }
    &-btn-large {
      height: 60px;
    }
  }
  .section {
    padding: 40px 0;
    font-size: 14px;
    color: $font-color2;
    h4 {
      font-size: 18px;
      color: #222222;
      font-weight: 400;
    }
    &-row {
      margin: 15px 0;
      // .label {
      //   width: 100px;
      // }
      .short-item {
        display: flex;
      }
      span + span {
        margin-left: 1em;
      }
      .v-btn {
        margin-top: -7.5px;
      }
    }
  }
  .icon-font{
    width: 18px;
    height: 18px;
    margin-right: 7px;
  }
}
</style>

